module.exports = __webpack_public_path__ + "static/media/red_car.270bf2ca.png";